module.exports = __webpack_public_path__ + "media/images/app/star-a29433bafbf8b5c51f63a7625bf35191.svg";